import React  from "react";
import { useParams } from 'react-router-dom';
import LeaveForm from "./components/AwardeeSelector";
import Card from "components/card";

const EditLeave = () => {

	const { leaveId } = useParams();

	return (
	    <div>
			<Card extra={"w-full h-full p-4"}>
				<div className="mt-5 grid h-full grid-cols-1 gap-4">
					<LeaveForm recordId={leaveId} mode="edit"/>
				</div>
			</Card>
	    </div>
    );
};

export default EditLeave;